import { useEffect } from "react";

/** Lightweight per-route document title — no external dependency. */
export function useSeoTitle(title) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
